import React, { useEffect } from 'react';

import LOGO from '../../img/logo-min.png';
import Nav from './Nav';
import Switch from '../switch/Switch';

const Navbar = () => {
    useEffect(() => {
        let scrollpos = window.scrollY;
        const header = document.querySelector('.orb-top-bar-frame');
        const header_height = header.offsetHeight;

        const add_class_on_scroll = () => header.classList.add('fade-in');
        const remove_class_on_scroll = () => header.classList.remove('fade-in');

        window.addEventListener('scroll', function () {
            scrollpos = window.scrollY;

            if (scrollpos >= header_height / 2) {
                add_class_on_scroll();
            } else {
                remove_class_on_scroll();
            }
        });
    });

    return (
        <div className="orb-top-bar-frame">
            <div className="orb-content orb-top-bar">
                <a
                    href="https://www.tarija.bo/"
                    target="_blank"
                    rel="noreferrer"
                    className="orb-logo-frame"
                >
                    <img
                        src={LOGO}
                        alt="Dirección Municipal de Turismo y Cultura Tarija"
                        className="logo"
                    ></img>
                </a>
                <div className="orb-right-side">
                    <div className="orb-menu-frame">
                        <Nav></Nav>
                    </div>
                </div>
                <div className="switch-position">
                    <Switch></Switch>
                    <div className="orb-menu-btn">
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Navbar;
